import { z } from 'zod';

import { zodPaginatedResponseSchema } from '@vestigas/data';

import { zodLinkableDlnItemFiltersSchema } from '../dlnItemLinks/validations';

export const zodLinkableDeliveryNotesQueryParamsSchema =
  zodLinkableDlnItemFiltersSchema.extend({
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().nonnegative().optional(),
  });

export const zodLinkableDeliveryNoteSchema = z.object({
  companyId: z.uuid().nullable(),
  companyName: z.string().nullable(),
  costCenters: z.array(z.string()),
  deliveryDate: z.iso.date().nullable(),
  deliveryNoteId: z.uuid(),
  deliveryNoteNumber: z.string(),
  lineCount: z.number().int().nonnegative(),
  sites: z.array(z.string()),
});

export const zodLinkableDeliveryNotesResponseSchema =
  zodPaginatedResponseSchema(zodLinkableDeliveryNoteSchema);
